// extracted by mini-css-extract-plugin
export default {"wrapper":"BaseBackdrop_wrapper__1wMh-","flex":"BaseBackdrop_flex__VGex+","button":"BaseBackdrop_button__4nxgZ"};